import { render, staticRenderFns } from "./OrderFromTemplateCartNotEmpty.vue?vue&type=template&id=2d2ffef3&scoped=true"
import script from "./OrderFromTemplateCartNotEmpty.vue?vue&type=script&lang=js"
export * from "./OrderFromTemplateCartNotEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ffef3",
  null
  
)

export default component.exports